<script>
  /* global Global */
  import Live from './live/Live.svelte';
  import SeparatorHorizontal from './SeparatorHorizontal.svelte';
  import Common from '../js/common.js';
  import { onDestroy } from 'svelte';

  let value = [];

  let timeoutId;

  (async function refresh () {
    if (!Global.live.timeout || new Date(Global.date.countdown).getTime() > new Date().getTime() || Global.live.standings.length > 0) return;

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/live/get`);

    if (response.ok) {
      const data = await response.json();

      value = data;
    }

    // eslint-disable-next-line no-magic-numbers
    timeoutId = setTimeout(refresh, Global.live.timeout);
  })();

  onDestroy(() => { clearTimeout(timeoutId); });
</script>

<div class='live-box'>
  {#each value as item, idx}
    <Live value={item}/>

    {#if idx !== value.length - 1}
      <SeparatorHorizontal/>
    {/if}
  {/each}
</div>

<style>
  .live-box {
    display: flex;
    flex-direction: column;
    gap: 20px;

    height: 100%;

    padding: 20px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  :global(body.dark) .live-box {
    background: var(--grey-8);
  }
</style>
